import { GeneralErrorBoundary, NotFoundError } from '#app/components/errors.tsx'
import type { Handle } from '#app/types/index.ts'

export { default, loader, meta } from './$.tsx'

export const handle: Handle = {
  getSitemapEntries: null,
}

export function ErrorBoundary() {
  return <GeneralErrorBoundary statusHandlers={{ 404: NotFoundError }} />
}
